import { sheetId, type SheetId } from "@electro-planner/domain";

export const GRID_SIZE = 10;

// ID:t för det default-sheet som useYjsDoc seedar in vid första öppning.
// Efter seed bestämmer sheetOrder vilket ark som är aktivt — se useSheetNavigation.
export const DEFAULT_SHEET_ID: SheetId = sheetId("sheet_default");

// Basdimensioner som Canvas rapporterar till PDF-export och title-block-renderingen.
// 48×48 viewBox i SVG-symbolerna renderas i 48×48 CSS-px på skärm.
export const SYMBOL_SIZE = 48;
